/* eslint-disable react/display-name */
import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Card,
  message,
  Menu,
  Dropdown,
  Button,
  Switch,
  Table,
} from "antd";
import SweetAlert from "react-bootstrap-sweetalert";
import Auxiliary from "util/Auxiliary";
import { useDispatch, useSelector } from "react-redux";
import {
  getTeacherDetails,
  updateDashboardFilter,
  getClassProgress,
} from "../../appRedux/actions/Dashboard";
import {
  GRADES,
  SECTIONS,
} from "../../constants/AppConstants";

import FormItem from "antd/lib/form/FormItem";
import CircularProgress from "components/CircularProgress";
import { DownOutlined, LoadingOutlined } from "@ant-design/icons";
import DummyContentAlert from "../../util/DummyContentAlert";
import {
  NotificationContainer,
} from "react-notifications";
import { chapter_progress_columns } from "./data";
import { map, sortBy } from "lodash";
const ClassProgress = () => {
  const dispatch = useDispatch();
  const {
    teacher_details,
    dashboard_filters = {},
    loader,
    showMessage,
    alertMessage,
    class_progress,
    loading_class_progress = false
  } = useSelector(({ dashboard }) => dashboard);
  const [level, setLevel] = useState(dashboard_filters.level || 10);
  const [section, setSection] = useState(dashboard_filters.section || "A");
  const [subject] = useState(
    dashboard_filters.subject || "physics"
  );
  const [showSubscribeAlert, setShowSubscribeAlert] = useState(false);
  const [board, setBoard] = useState(
    dashboard_filters ? dashboard_filters.board : "CBSE"
  );
  // let selectedChapter = null;
  
  // let onTocSelected= null
  // console.log(height,width);
  
  const getSubjectProgress = (progress, subject) => {
    if (!progress) return []
    let subjectresult = progress.filter(p=>p.course.subject === subject)[0];// find(progress, { "name": subject });
    if (subjectresult)
      return map(sortBy(subjectresult.chapters,"sequence"), (x)=>{return {...x, subjectname:subject}});
    return [];
  }
  useEffect(() => {
    if(!teacher_details){
      dispatch(getTeacherDetails());
    }
  }, []);
  useEffect(() => {
    if (teacher_details) {
      dispatch(getClassProgress());
    }
    else{
      dispatch(getTeacherDetails());
    }
  }, [teacher_details]);
  useEffect(() => {
    updateFilters();
  }, [level, subject, board,section]);
  const updateFilters = () => {
    const payload = {
      board: board,
      level: level,
      subject: subject,
      section: section
    };
    dispatch(updateDashboardFilter(payload));
    dispatch(getClassProgress());
  };

  return (
    <Auxiliary>
      <SweetAlert
        show={showSubscribeAlert}
        warning
        showCancel
        confirmBtnText="Ok"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        title={
          "Your account is not verified yet.\n You cannot assign quizzes to your class till we verify that you are an authorized person and working at this school. Contact support@quiznext.in for assistance."
        }
        onConfirm={() => {
          setShowSubscribeAlert(false);
        }}
        onCancel={() => {
          setShowSubscribeAlert(false);
        }}
      ></SweetAlert>
      <Card 
          style={{...styles.filter_card_container}} 
          bodyStyle={{...styles.filter_card_body}}>
        <Switch
          style={{ position: "absolute", right: 5, top: 5 }}
          checkedChildren="CBSE"
          unCheckedChildren="ICSE"
          defaultChecked
          onChange={(v) => setBoard(v ? "CBSE" : "ICSE")}
          checked={board === "CBSE"}
          className="gx-qn-switch"
          size={"small"}
        />
        <Row title="Select class and subject" style={{paddingLeft:"10px",paddingTop:"25px",margin:"0px"}}>
          <Col xl={4} lg={4} md={6} sm={10} xs={10}>
            <FormItem
              label="Grades"
              className="gx-form-item-one-fourth"
              labelAlign="left"
              labelCol={0}
            >
              <Dropdown
                overlay={
                  <Menu
                    value={level}
                    onClick={(e) => {
                      setLevel(parseInt(e.key));
                    }}
                  >
                    {GRADES.map((grade) => (
                      <Menu.Item key={grade}>{grade}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Button>
                  {level} <DownOutlined />
                </Button>
              </Dropdown>
            </FormItem>
          </Col>
          <Col xl={4} lg={4} md={6} sm={10} xs={10}>
            <FormItem
              label="Section"
              className="gx-form-item-one-fourth"
              labelAlign="left"
              labelCol={0}
            >
              <Dropdown
                overlay={
                  <Menu
                    value={level}
                    onClick={(e) => {
                      // console.log(e);
                      setSection(e.key);
                    }}
                  >
                    {SECTIONS.map((section) => (
                      <Menu.Item key={section}>{section}</Menu.Item>
                    ))}
                  </Menu>
                }
              >
                <Button>
                  {section} <DownOutlined />
                </Button>
              </Dropdown>
            </FormItem>
          </Col>
          <Col xl={1} lg={1} md={1} sm={1} xs={1} style={{paddingTop:"10px"}}>
              {loading_class_progress && <LoadingOutlined style={{fontSize:"20px", fontWeight:"bold", color:"secondary"}}/>}
          </Col>
        </Row>
      </Card>
      <Row>
        <Col span={24}>
          <div className="gx-card">
            <div className="gx-card-body">
              <Row>
                <DummyContentAlert
                  subscribed={
                    teacher_details ? teacher_details.subscribed : false
                  }
                />
              </Row>
              <Row>
                <Row>
                  <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                    <Card title="Maths">
                      <Table showHeader={false} columns={chapter_progress_columns} dataSource={getSubjectProgress(class_progress, "maths")} pagination={false} size="small" ></Table>
                    </Card>
                  </Col>
                  <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                    <Card title="Physics">
                      <Table  showHeader={false}  columns={chapter_progress_columns} dataSource={getSubjectProgress(class_progress, "physics")} pagination={false} size="small"></Table>
                    </Card>
                  </Col>
                  <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                    <Card title="Chemistry">
                      <Table   showHeader={false} columns={chapter_progress_columns} dataSource={getSubjectProgress(class_progress, "chemistry")} pagination={false} size="small"></Table>
                    </Card>
                  </Col>
                  <Col xl={6} lg={12} md={12} sm={12} xs={24}>
                    <Card title="Biology">
                      <Table  showHeader={false}  columns={chapter_progress_columns} dataSource={getSubjectProgress(class_progress, "biology")}  pagination={false} size="small"></Table>
                    </Card>
                  </Col>
                </Row>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
      {/* <div className="gx-loader-view">
        <CircularProgress />
      </div> */}
      {loader ? (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      ) : null}
      {showMessage ? message.error(alertMessage.toString()) : null}
      <NotificationContainer />
    </Auxiliary>
  );
};
const styles = {
  filter_card_container:{padding:"0px"},
  filter_card_body:{
    padding:"0px", margin:"0px"
  }
}
export default ClassProgress;
